import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ts } from 'utils/theme';

const MainContent = styled.main`
  display: ${(p) => (p.menuOpen ? 'none' : 'grid')};
  height: ${(p) => `calc(100vh - ${ts('appHeaderHeight')(p)})`};
`;

const ContentBody = styled.div`
  padding: 0;
  overflow: auto;
`;

const AppContent = (props) => (
  <MainContent {...props}>
    <ContentBody className="content-body">{props.children}</ContentBody>
  </MainContent>
);

AppContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppContent;
